export type ListsType = (project: "glory" | "banger") => ListType[];

export type ListType = {
  id: number;
  title: string;
  description: string;
};

export type KycList = (project: "glory" | "banger") => KycListType[];

export type KycListType = {
  id: number;
  title: string;
  subTitle: string;
  description: string;
};

export type PrivacyList = (project: "glory" | "banger") => PrivacyListType[];

export type PrivacyListType = {
  id: number;
  header: string;
  title: string;
  description: string;
};

export type SupportItem = (project: "glory" | "banger") => SupportItemModel[];

export type SupportItemModel = {
  id: number;
  image: JSX.Element;
  title: string;
  description: string;
  notice: string;
};

export type PromoType = {
  img: JSX.Element;
  title: string;
  description_first: string;
  description_second: string;
  description_third: string;
};

export type WelcomeDescriptionType = {
  title: string;
  description: string;
};

export type BonusType = {
  currency: string;
  min: number;
  max: number;
  freeSpins: number;
};

export enum NewGloryEnum {
  PASSWORD = 1,
  AUTH,
  SUPPORT,
}
export enum NewGloryUpdateEnum {
  TABBAR = 1,
  REFERRAL,
  PROMOTION,
  BONUSES,
}

export type NewGloryType = {
  id: number;
  icon: JSX.Element;
  title: string;
  description: string;
  buttonText: string;
  url: string;
};

export type NewGloryUpadteType = {
  id: number;
  image: string;
  title: string;
  description: string;
  url: string;
};
